"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tiny_emitter_1 = require("tiny-emitter");
const Store_1 = require("./Store");
const Network_1 = require("./Network");
exports.PFDefaultEvaluation = { featureFlags: {}, remoteConfigs: {} };
const AnonymousUser = {
    id: "anonymous",
    context: {}
};
class PFClient {
    constructor(apiKey, user, options) {
        this.apiKey = apiKey;
        this.user = user;
        this.options = options;
        this.emitter = null;
        if (!apiKey)
            throw new Error('apiKey is required');
        if (!options)
            throw new Error('options is required');
        const clientUser = user !== null && user !== void 0 ? user : AnonymousUser;
        this.emitter = new tiny_emitter_1.TinyEmitter();
        this.store = Store_1.Store.create(options.storage);
        this.store.onReady(() => this.emitter.emit('ready'));
        this.store.onChanges(() => this.emitter.emit('changes'));
        this.store.tryInitialize();
        const network = new Network_1.Network(apiKey, clientUser, options.baseUrl, options.pathUrl, options.timeout);
        network.onSuccess((evaluation) => this.store.persist(evaluation));
        network.onError((error) => this.store.forceInitialize(options.fallback));
        network.onUnauthorized((error) => this.emitter.emit('error', error));
        if (typeof options.poolingInterval == "number" && options.poolingInterval >= 1) {
            this.configureAutoPollingClient(network, options.poolingInterval);
        }
        else {
            this.initializeNetwork(network);
        }
    }
    static initialize(apiKey, user, options) {
        if (PFClient._intervalRef)
            clearInterval(PFClient._intervalRef);
        return new PFClient(apiKey, user, options || {});
    }
    configureAutoPollingClient(network, pollingInterval) {
        if (PFClient._intervalRef)
            clearInterval(PFClient._intervalRef);
        PFClient._intervalRef = setInterval(() => {
            this.initializeNetwork(network);
        }, pollingInterval);
    }
    initializeNetwork(network) {
        network.initialize();
    }
    onReady(callback) {
        if (this.store.isInitialized()) {
            callback();
        }
        else {
            this.emitter.on('ready', callback);
        }
    }
    onIdentified(callback) {
        this.emitter.on('identified', callback);
    }
    onChanges(callback) {
        this.emitter.on('changes', callback);
    }
    onError(callback) {
        this.emitter.on('error', callback);
    }
    // Deprecated
    flag(key) {
        return this.isEnabled(key);
    }
    isEnabled(releaseToggleKey) {
        return this.releaseToggles()[releaseToggleKey] || false;
    }
    valueOf(remoteConfigKey, fallback) {
        return this.remoteConfigs()[remoteConfigKey] || fallback || null;
    }
    releaseToggles() {
        return this.evaluation().featureFlags;
    }
    remoteConfigs() {
        return this.evaluation().remoteConfigs;
    }
    identify(user) {
        this.user = user;
        const network = new Network_1.Network(this.apiKey, user, this.options.baseUrl, this.options.pathUrl, this.options.timeout);
        network.onSuccess((evaluation) => {
            this.store.persist(evaluation);
            this.emitter.emit('identified');
        });
        network.initialize();
    }
    refresh() {
        const network = new Network_1.Network(this.apiKey, this.user, this.options.baseUrl, this.options.pathUrl, this.options.timeout);
        network.onSuccess((evaluation) => {
            this.store.persist(evaluation);
            this.emitter.emit('changes');
        });
        network.initialize();
    }
    evaluation() {
        return this.store.ensureEvaluation();
    }
    event(name, data) {
        const params = { headers: { "x-api-key": this.apiKey } };
        const event = new Event(name, data);
        return this.httpClient.post('/proxy/events', event, params)
            .then(({ data }) => {
            return Promise.resolve();
        })
            .catch((reason) => {
            this.emitter.emit('error', reason);
        });
    }
    _dispose() {
        if (PFClient._intervalRef)
            clearInterval(PFClient._intervalRef);
    }
}
exports.PFClient = PFClient;
//# sourceMappingURL=PFClient.js.map